import { PrintClient, ScenarioSettings } from "src/types";
import SpendingTable from "../Spending/SpendingTable";
import Header from "./Header";
import Footer from "./Footer";
import { useUser } from "src/hooks/useUser";

const Spending = ({
  scenario,
  client,
}: {
  scenario: ScenarioSettings;
  client: PrintClient;
}) => {
  const { user } = useUser();
  console.log("U", user);
  if (!user?.info?.needsFlag) return null;
  return (
    <div className="mx-5 flex justify-center flex-col">
      <Header client={client} scenario={scenario} page="Spending" />
      <Footer client={client} scenario={scenario} />
      <SpendingTable print client={client} settings={scenario} />
    </div>
  );
};

export default Spending;
